import { createContext, useState, useEffect } from "react"
import { userLogin, logoutUser} from "../services/authServices.js"
import {unsubscribe} from "../services/notificationService.js"
import { setAccessToken } from "../services/auth.js"
import {renovarToken} from "../services/api.js"

export const AuthContext = createContext()

export function AuthProvider({children}) {

    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)

    const getUser = async () => {
        try {
            console.log('1. llamando renovarToken...')
            const data = await renovarToken()
            console.log('2. respuesta renovarToken:', data)
            if (!data) throw new Error()
            setUser(data.user)
            console.log('3. user seteado:', data.user)
        } catch {
            console.log('4. falló, user = null')
            setUser(null)
        } finally {
            setLoading(false)
        }
    }

    const login = async (name_user, password_user) => {
        const user = await userLogin(name_user, password_user)
        console.log(user)
        setUser(user)
    }

    const logout = async () => {
        await unsubscribe()
        await logoutUser()
        setAccessToken(null)
        setUser(null)
    }

    useEffect(() => {
        getUser()
    }, [])

    return (
        <AuthContext.Provider value={{user, getUser, loading, login, logout}}>
            {children}
        </AuthContext.Provider>
    )
}